import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryHeatingTWS extends React.Component {
    render() {
        const heatExchangerOutput = this.props.heatingModel.heatExchangerOutput || []
        const hasHeatExchangerOutput = heatExchangerOutput.length > 0

        return (
            <ExpandableContainer label={this.props.heatingModel.name.value}>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        {this.renderHeatExchanger()}
                        <div style={{width: '100%', height: '2.5rem'}}></div>
                        {hasHeatExchangerOutput && this.renderOutputData(heatExchangerOutput)}
                    </Row.Column6>
                </Row.Container>
                <Row.Container hasOuterGutter={false}>
                    {this.isTanksAvailable() &&
                        <Row.Column6>
                            <div style={{width: '100%', height: '2.5rem'}}></div>
                            {this.renderTanks()}
                        </Row.Column6>}
                    {this.isSecondarySideComponentsAvailable() &&
                        <Row.Column6>
                            <div style={{width: '100%', height: '2.5rem'}}></div>
                            {this.renderSecondarySideComponents()}
                        </Row.Column6>}
                    {this.isPumpAvailable() &&
                        <Row.Column6>
                            <div style={{width: '100%', height: '2.5rem'}}></div>
                            {this.renderPumps()}
                        </Row.Column6>}
                </Row.Container>
            </ExpandableContainer>
        )
    }

    renderHeatExchanger() {
        if (this.props.heatingModel.heatExchanger.value == null)
            return <React.Fragment></React.Fragment>

        const heatExchangerName = this.props.heatingModel.heatExchanger.items.find(x => x.value == this.props.heatingModel.heatExchanger.value).text;
        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Heat exchanger')}</div>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        <div className="configuration-editor-summary-heating-field">
                            <div>{__('Model')}</div>
                            <div>{heatExchangerName}</div>
                        </div>
                    </Row.Column6>
                </Row.Container>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        <div className="configuration-editor-summary-heating-field" style={{marginTop: ".75rem"}}>
                            <div>{__('Capacity')}</div>
                            <div>{this.props.heatingModel.capacity.value} {this.props.heatingModel.capacity.unit}</div>
                        </div>
                    </Row.Column6>
                </Row.Container>
            </div>
        )
    }

    renderOutputData(output) {
        const renderRows = () => {
            let result = []

            for (let row of output) {
                result.push(
                    <tr key={output.indexOf(row)}>
                        <td>{row.name}</td>
                        <td>{row.primary}</td>
                        <td>{row.secondary}</td>
                        <td>{row.unit}</td>
                    </tr>
                )
            }

            return result
        }

        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('Heating output')}</div>
                <div className="configuration-editor-summary-table-wrapper">
                    <table className="configuration-editor-summary-table-multi">
                        <thead>
                        <tr>
                            <th></th>
                            <th>{__('Primary')}</th>
                            <th>{__('Secondary')}</th>
                            <th>{__('Unit')}</th>
                        </tr>
                        </thead>

                        <tbody>
                        {renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderTanks() {
        const heatingModel = this.props.heatingModel

        let results = []
        if (this.isFieldAvailable(heatingModel.tank)) {
            results.push({
                label: heatingModel.tank.label,
                value: this.getFieldValue(heatingModel.tank)
            })
        }

        if (this.isFieldAvailable(heatingModel.tankInsulation)) {
            results.push({
                label: heatingModel.tankInsulation.label,
                value: this.getFieldValue(heatingModel.tankInsulation)
            })
        }

        if (this.isFieldAvailable(heatingModel.tankHeater)) {
            results.push({
                label: heatingModel.tankHeater.label,
                value: this.getFieldValue(heatingModel.tankHeater)
            })
        }

        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Tanks')}</div>
                <div className="column-6 column-xs-12">
                    <div className="configuration-editor-summary-table-wrapper">
                        <table className="configuration-editor-summary-table">
                            <tbody>
                            {results.map((r, idx) => (
                                <tr key={idx}>
                                    <td>{r.label}</td>
                                    <td>{this.getFieldValue(r)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    renderSecondarySideComponents() {
        const heatingModel = this.props.heatingModel

        let results = []
        if (this.isFieldAvailable(heatingModel.controlValve)) {
            results.push({
                label: heatingModel.controlValve.label,
                value: this.getFieldValue(heatingModel.controlValve)
            })
        }

        if (this.isFieldAvailable(heatingModel.primaryActuator)) {
            results.push({
                label: heatingModel.primaryActuator.label,
                value: this.getFieldValue(heatingModel.primaryActuator)
            })
        }

        if (this.isFieldAvailable(heatingModel.secondaryActuator)) {
            results.push({
                label: heatingModel.secondaryActuator.label,
                value: this.getFieldValue(heatingModel.secondaryActuator)
            })
        }

        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Secondary side components')}</div>
                <div className="column-6 column-xs-12">
                    <div className="configuration-editor-summary-table-wrapper">
                        <table className="configuration-editor-summary-table">
                            <tbody>
                            {results.map((r, idx) => (
                                <tr key={idx}>
                                    <td>{r.label}</td>
                                    <td>{this.getFieldValue(r)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    isTanksAvailable() {
        const heatingModel = this.props.heatingModel

        return (
            this.isFieldAvailable(heatingModel.tank) ||
            this.isFieldAvailable(heatingModel.tankInsulation) ||
            this.isFieldAvailable(heatingModel.tankHeater)
        )
    }

    isSecondarySideComponentsAvailable() {
        const heatingModel = this.props.heatingModel

        return (
            this.isFieldAvailable(heatingModel.controlValve) ||
            this.isFieldAvailable(heatingModel.primaryActuator) ||
            this.isFieldAvailable(heatingModel.secondaryActuator)
        )
    }

    isPumpAvailable() {
        const heatingModel = this.props.heatingModel

        return (
            this.isFieldAvailable(heatingModel.primaryPump) ||
            this.isFieldAvailable(heatingModel.secondaryPump) ||
            this.isFieldAvailable(heatingModel.circulationPump)
        )
    }

    isFieldAvailable = x => (typeof x !== 'undefined' && x.value && x.visible)

    getFieldValue(field) {
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }

    renderPumps() {
        const data = [this.props.heatingModel.primaryPumpData, this.props.heatingModel.secondaryPumpData, this.props.heatingModel.circulationPumpData].filter(x => x.visible);
        const renderLabel = prop => <td>{data.length > 0 ? data[0][prop].label : ''}</td>;
        const renderValues = prop => data.map((x, idx) => (<td key={idx}>{x[prop].value}</td>));
        const renderUnit = prop => <td>{data.length > 0 ? data[0][prop].unit : ''}</td>;

        var content =
            <React.Fragment>
                <thead>
                <tr>
                    <th></th>
                    {this.props.heatingModel.primaryPump.visible &&
                        <th>{this.props.heatingModel.primaryPump.label}</th>}
                    {this.props.heatingModel.secondaryPump.visible &&
                        <th>{this.props.heatingModel.secondaryPump.label}</th>}
                    {this.props.heatingModel.circulationPump.visible &&
                        <th>{this.props.heatingModel.circulationPump.label}</th>}
                    <th>{__('Unit')}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{__('Pump')}</td>
                    {this.props.heatingModel.primaryPump.visible &&
                        <td>{this.getFieldValue(this.props.heatingModel.primaryPump)}</td>}
                    {this.props.heatingModel.secondaryPump.visible &&
                        <td>{this.getFieldValue(this.props.heatingModel.secondaryPump)}</td>}
                    {this.props.heatingModel.circulationPump.visible &&
                        <td>{this.getFieldValue(this.props.heatingModel.circulationPump)}</td>}
                    <td></td>
                </tr>
                <tr>
                    <td>{__('Max lifting height')}</td>
                    {renderValues('pumpLiftingHeight')}
                    {renderUnit('pumpLiftingHeight')}
                </tr>
                <tr>
                    {renderLabel('pumpVoltage')}
                    {renderValues('pumpVoltage')}
                    {renderUnit('pumpVoltage')}
                </tr>
                <tr>
                    {renderLabel('maxPower')}
                    {renderValues('maxPower')}
                    {renderUnit('maxPower')}
                </tr>
                <tr>
                    {renderLabel('maxCurrent')}
                    {renderValues('maxCurrent')}
                    {renderUnit('maxCurrent')}
                </tr>
                <tr>
                    {renderLabel('pumpFlow')}
                    {renderValues('pumpFlow')}
                    {renderUnit('pumpFlow')}
                </tr>
                </tbody>
            </React.Fragment>

        return (
            this.renderTableContainer('Pumps', content)
        )
    }

    renderTableContainer(title, content) {
        return (
            <React.Fragment>
                <div className="configuration-editor-summary-ut-section">
                    <div>{__(title)}</div>
                    <div className="configuration-editor-summary-table-wrapper">
                        <table className="configuration-editor-summary-table-multi">
                            {content}
                        </table>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
